import { Typography, Tooltip } from '@mui/material'
import { colors } from 'Themes/Colors'
import { styled } from '@mui/material/styles'
import { InfoOutlined } from '@mui/icons-material'

type Props = {
  children?: React.ReactNode
  text: string
  placement:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | undefined
  icon?: React.ReactNode
  styles?: React.CSSProperties
}

const TooltipSong: React.FC<Props> = ({
  children,
  text,
  placement,
  icon,
  styles,
}) => (
  <Tooltip
    placement={placement}
    arrow
    componentsProps={{
      tooltip: {
        sx: {
          maxWidth: `188px`,
          background: colors.darkestBlue,
          color: colors.resiliaWhite,
          padding: '20px',
          borderRadius: '8px',
          border: 'none',
          fontWeight: 700,
          ...styles,
        },
      },
      arrow: {
        sx: {
          color: colors.darkestBlue,
        },
      },
    }}
    title={<Title>{text}</Title>}
  >
    {children ? (
      <span>{children}</span>
    ) : (
      <IconContainer>{icon || <InfoOutlined />}</IconContainer>
    )}
  </Tooltip>
)

export default TooltipSong

const IconContainer = styled('span')`
  display: inline-flex;

  svg {
    margin-left: 4px;
    color: ${colors.darkGrey};
    font-size: inherit;
  }
`

const Title = styled(Typography)`
  font-weight: 700;
`
